var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"numeric-keyboard flex"},[_c('Btn',{attrs:{"text":"1","center":""},nativeOn:{"click":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
$event.stopPropagation();_vm.setValue.apply(void 0, argsArray.concat( [1] ))}}}),_vm._v(" "),_c('Btn',{attrs:{"text":"2","center":""},nativeOn:{"click":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
$event.stopPropagation();_vm.setValue.apply(void 0, argsArray.concat( [2] ))}}}),_vm._v(" "),_c('Btn',{attrs:{"text":"3","center":""},nativeOn:{"click":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
_vm.setValue.apply(void 0, argsArray.concat( [3] ))}}}),_vm._v(" "),_c('Btn',{attrs:{"text":"4","center":""},nativeOn:{"click":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
_vm.setValue.apply(void 0, argsArray.concat( [4] ))}}}),_vm._v(" "),_c('Btn',{attrs:{"text":"5","center":""},nativeOn:{"click":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
_vm.setValue.apply(void 0, argsArray.concat( [5] ))}}}),_vm._v(" "),_c('Btn',{attrs:{"text":"6","center":""},nativeOn:{"click":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
_vm.setValue.apply(void 0, argsArray.concat( [6] ))}}}),_vm._v(" "),_c('Btn',{attrs:{"text":"7","center":""},nativeOn:{"click":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
_vm.setValue.apply(void 0, argsArray.concat( [7] ))}}}),_vm._v(" "),_c('Btn',{attrs:{"text":"8","center":""},nativeOn:{"click":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
_vm.setValue.apply(void 0, argsArray.concat( [8] ))}}}),_vm._v(" "),_c('Btn',{attrs:{"text":"9","center":""},nativeOn:{"click":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
_vm.setValue.apply(void 0, argsArray.concat( [9] ))}}}),_vm._v(" "),_c('Btn',{attrs:{"icon":"back","center":""},nativeOn:{"click":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
_vm.setValue.apply(void 0, argsArray.concat( [-1] ))}}}),_vm._v(" "),_c('Btn',{attrs:{"text":"0","center":""},nativeOn:{"click":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
_vm.setValue.apply(void 0, argsArray.concat( [0] ))}}}),_vm._v(" "),_c('Btn',{attrs:{"icon":"ok","center":""},nativeOn:{"click":function($event){
var i = arguments.length, argsArray = Array(i);
while ( i-- ) argsArray[i] = arguments[i];
_vm.setValue.apply(void 0, argsArray.concat( [-2] ))}}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe5f76c4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/basic/KeyboardNumeric.vue
// module id = DXG0
// module chunks = 1